module.exports = __webpack_public_path__ + "f057dea547416d3bc795db41e990a034.svg";